import { render, staticRenderFns } from "./FareConditionsTable.vue?vue&type=template&id=0a48c25d&scoped=true&"
import script from "./FareConditionsTable.vue?vue&type=script&lang=js&"
export * from "./FareConditionsTable.vue?vue&type=script&lang=js&"
import style0 from "./FareConditionsTable.vue?vue&type=style&index=0&id=0a48c25d&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48c25d",
  null
  
)

export default component.exports